var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMwk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3261)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#E11C1B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V9.58333H23V0H0Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87617 13.3648V13.3625L2.86945 13.364L2.87617 13.3648ZM3.32787 9.70489H3.4019L3.28844 9.68172L3.32787 9.70489ZM5.43203 9.70489C5.46966 9.60844 5.50895 9.51303 5.54985 9.41872L3.90431 7.96636L5.84521 8.80819C5.95376 8.6058 6.07014 8.40957 6.19387 8.22007L4.76757 6.40947L6.58517 7.67411C6.71851 7.50436 6.85826 7.34141 7.00399 7.18578L5.85047 5.06111L7.47955 6.72277C7.63109 6.58845 7.78773 6.46137 7.94907 6.34199L7.11821 3.96461L8.49436 5.97875C8.65837 5.88098 8.8263 5.79072 8.99781 5.70838L8.53003 3.15521L9.59561 5.45899C9.76716 5.39786 9.94163 5.3444 10.1187 5.29894L10.0406 2.65892L10.7494 5.17302C10.9244 5.14786 11.1015 5.13042 11.2804 5.12099L11.6013 2.4917L11.9223 5.12176C12.101 5.13161 12.2778 5.14945 12.4526 5.17499L13.162 2.65892L13.0837 5.30257C13.2602 5.34832 13.434 5.40202 13.6049 5.46334L14.6725 3.15521L14.2036 5.71465C14.3741 5.79699 14.541 5.88716 14.7041 5.98476L16.0843 3.96461L15.2506 6.35034C15.4106 6.46929 15.566 6.59582 15.7164 6.72949L17.3521 5.06111L16.1933 7.19537C16.3377 7.35006 16.4761 7.51193 16.6082 7.68049L18.435 6.40947L17.0009 8.22991C17.1233 8.41793 17.2384 8.61253 17.3458 8.81318L19.2982 7.96636L17.6424 9.42777C17.6819 9.51913 17.7199 9.61152 17.7563 9.70489H16.3441C15.3708 7.90609 13.592 6.70182 11.5588 6.70182C9.52564 6.70182 7.74679 7.90609 6.77354 9.70489H5.43203ZM7.58975 9.70489C8.51183 8.43683 9.95967 7.6198 11.5877 7.6198C13.2157 7.6198 14.6635 8.43683 15.5856 9.70489H7.58975ZM19.8006 9.70489H19.8747L19.9141 9.68172L19.8006 9.70489ZM20.3274 13.3627L20.3331 13.364L20.3274 13.3647V13.3627Z",
    fill: "#E11C1B"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3261)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3261",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwk);
export default __webpack_public_path__ + "static/media/MWK.f276928457b1a50af6a110e0fc317c83.svg";
export { ForwardRef as ReactComponent };